import * as React from "react";

function SvgSlant1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="slant-1_svg__st2" d="M-10 210h1620V.5L-10 183.9z" /></svg>;
}

export default SvgSlant1;